import { IconAlert } from '@consta/icons/IconAlert'
import { Placeholder } from '@core/components'
import { selectMultipartProgress, useAppSelector } from '@core/core/store'
import type { FC } from 'react'

import { css, LabeledTimer } from '../../Common'
import type { StepProps } from '../../types'

export const Loading: FC<StepProps> = ({ file }) => {
  const progress = Math.floor(
    useAppSelector(state => selectMultipartProgress(state, file.fileId)) ?? 0,
  )

  const loadingStatus = file.uploadedFile?.statuses?.loading
  const isLoadingStatusFailed = loadingStatus === 'failed'
  return (
    <div className={css.loadingFrame}>
      {loadingStatus === 'paused' || isLoadingStatusFailed ? (
        <Placeholder
          className={css.loadingFrame}
          icon={<IconAlert className={css.iconStyle} size="m" view="alert" />}
          title={isLoadingStatusFailed ? 'Не удалось загрузить файл' : 'Загрузка приостановлена'}
          description={isLoadingStatusFailed ? null : 'Нажмите Продолжить загрузку'}
        />
      ) : (
        <LabeledTimer progress={progress} text="Загружаем..." />
      )}
    </div>
  )
}
